import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _root;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { alpha, createTheme, hexToRgb, styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { PROMETHEAN_TYPOGRAPHY_SUBTITLE_02, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04, PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE } from '../styles/typography/typography';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_TEXT_HEADER, PROMETHEAN_APP_SWITCHER_BG, PROMETHEAN_TEXT, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_MID_PURPLE, PROMETHEAN_BLUE, PROMETHEAN_DARK_PURPLE } from '../styles/colors/colors';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE } from '../styles/breakpoints/breakpoints';
import { EMBERS_HEADER_HEIGHT, EMBERS_HEADER_HEIGHT_MOBILE } from '../header/headerStyles';
export var ROOT_PREFIX_LOADING = 'EmbersAppSwitcher-loading';
export var appSwitcherTheme = createTheme({
  components: {
    MuiDrawer: {
      styleOverrides: {
        root: (_root = {
          top: EMBERS_HEADER_HEIGHT
        }, _defineProperty(_root, "@media screen and (max-width:".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"), {
          top: EMBERS_HEADER_HEIGHT_MOBILE
        }), _defineProperty(_root, "userSelect", 'none'), _defineProperty(_root, '.MuiList-root', {
          paddingTop: 16,
          paddingBottom: 18
        }), _defineProperty(_root, '.EmbersAppSwitcher-title', _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
          color: PROMETHEAN_NEUTRAL_WHITE,
          background: PROMETHEAN_APP_SWITCHER_BG,
          width: '100%',
          height: 40,
          padding: '8px 23px',
          boxSizing: 'border-box',
          userSelect: 'none'
        })), _defineProperty(_root, '.EmbersAppSwitcher-extraTitle', _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE), {}, {
          color: PROMETHEAN_TEXT_HEADER,
          margin: '18px 8px 0 8px'
        })), _defineProperty(_root, '.EmbersAppSwitcher-error, .EmbersAppSwitcher-empty', {
          padding: '16px 28px 16px 24px'
        }), _defineProperty(_root, '.MuiBackdrop-root', {
          opacity: '0 !important'
        }), _defineProperty(_root, '.MuiPaper-root', {
          boxShadow: "-2px 2px 0 2px ".concat(hexToRgb(PROMETHEAN_PURPLE_GRAPE), " inset"),
          top: 'inherit'
        }), _defineProperty(_root, '.MuiBox-root', {
          padding: '0 12px 0 8px',
          '::-webkit-scrollbar-track': {
            marginTop: 12
          },
          '.MuiList-root li': {
            '&:not(:last-child)': {
              marginBottom: 16
            }
          },
          '.MuiListItem-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_04), {}, {
            cursor: 'pointer',
            borderRadius: 4,
            '&.EmbersAppSwitcher-item': {
              width: '100%',
              height: '100%',
              borderRadius: 4,
              backgroundColor: 'transparent',
              color: PROMETHEAN_TEXT_HEADER,
              justifyContent: 'space-between',
              alignItems: 'center',
              minHeight: 44,
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              border: '1px solid transparent',
              fontWeight: 400,
              padding: '9px 7px 9px 12px',
              '&:has(button)': {
                padding: '4px 5px 4px 12px'
              },
              '&.EmbersAppSwitcher-item-non-selectable': {
                justifyContent: 'start',
                alignItems: 'flex-start'
              },
              '[class^="icon-"]': {
                color: PROMETHEAN_TEXT
              },
              '.EmbersAppSwitcher-item-iconName-group': {
                display: 'flex',
                alignItems: 'baseline'
              },
              '.EmbersAppSwitcher-item-icon': {
                width: 24,
                height: 24,
                marginRight: 16
              },
              '.EmbersAppSwitcher-item-icon-externalLink': {
                zIndex: 1,
                marginRight: 2
              },
              '.EmbersAppSwitcher-item-icon-inline': {
                width: 20,
                height: 24,
                marginRight: 4,
                marginBottom: 0,
                marginLeft: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: PROMETHEAN_TEXT,
                '.icon-open-in': {
                  margin: 0,
                  fontSize: 16
                }
              },
              '&:hover': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                border: "1px solid ".concat(PROMETHEAN_MID_PURPLE)
              },
              // Possibly just a temporary solution
              // This is not supported by ie and opera mini
              '&:focus-within': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                border: "1px solid ".concat(PROMETHEAN_MID_PURPLE)
              },
              '&:focus-visible': {
                backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                border: "2px solid ".concat(PROMETHEAN_BLUE),
                padding: '8px 4px 8px 12px',
                '&:has(button)': {
                  padding: '0px 4px 0px 12px'
                },
                '.EmbersAppSwitcher-item-icon': {
                  marginLeft: '-1px'
                }
              },
              '&:active': {
                backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.4),
                border: "1px solid ".concat(PROMETHEAN_MID_PURPLE),
                // focus style overwrites active if someone clicks and holds and tabs at the same time
                '&:focus-visible': {
                  backgroundColor: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1),
                  border: "2px solid ".concat(PROMETHEAN_BLUE),
                  padding: '8px 4px 8px 12px',
                  '&:has(button)': {
                    padding: '0px 4px 0px 12px'
                  },
                  '.EmbersAppSwitcher-item-icon': {
                    marginLeft: '-1px'
                  }
                }
              },
              '&.current': {
                backgroundColor: PROMETHEAN_PURPLE_GRAPE,
                color: PROMETHEAN_NEUTRAL_WHITE,
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: PROMETHEAN_PURPLE_GRAPE,
                  color: PROMETHEAN_NEUTRAL_WHITE
                },
                '&:focus': {
                  backgroundColor: PROMETHEAN_PURPLE_GRAPE,
                  color: PROMETHEAN_NEUTRAL_WHITE
                },
                '&:active': {
                  backgroundColor: PROMETHEAN_PURPLE_GRAPE,
                  color: PROMETHEAN_NEUTRAL_WHITE
                },
                '&:focus-visible': {
                  boxShadow: "".concat(PROMETHEAN_NEUTRAL_WHITE, " 0 0 0 1px inset"),
                  border: "2px solid ".concat(PROMETHEAN_BLUE),
                  '.EmbersAppSwitcher-item-icon': {
                    marginLeft: '-1px'
                  }
                },
                '[class^="icon-"]': {
                  color: PROMETHEAN_NEUTRAL_WHITE
                }
              },
              '&.disabled': {
                backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
                color: PROMETHEAN_NEUTRAL_DARK_GREY,
                border: '1px solid transparent',
                cursor: 'default',
                '[class^="icon-"]': {
                  color: PROMETHEAN_NEUTRAL_DARK_GREY
                }
              }
            }
          })
        }), _defineProperty(_root, '&.EmbersAppSwitcher-withScroll .MuiBox-root', {
          padding: '0 6px 0 8px',
          marginRight: 8
        }), _root)
      }
    }
  }
});
export var StyledSkeleton = styled(Stack)(function () {
  return {
    width: 'calc(100% - 52px)',
    margin: '26px 28px 0 24px',
    '> div': {
      height: 24,
      alignItems: 'center'
    }
  };
});